import { type EffectStep, parseStepId, stepId } from './effect-ladder.ts'
import { type KeyValueStore, readStored, writeStored } from './key-value-store.ts'
import type { SegmenterPlatform, SegmenterTierFiles } from './segmenter-catalog.ts'
import { PROBE_PIPELINE_REVISION } from './segmenter-tiers.ts'

export interface EffectMemory {
  step: EffectStep
  at: number
}

const KEY_PREFIX = 'reconforta-effect-memory'

export function effectMemoryKey(files: SegmenterTierFiles, browserMajor: number): string {
  const major = Number.isFinite(browserMajor) ? Math.floor(browserMajor) : 0
  return [KEY_PREFIX, files.heavy, files.light, `b${major}`, `r${PROBE_PIPELINE_REVISION}`].join(
    ':',
  )
}

function isEpochMs(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value > 0
}

export function readEffectMemory(
  store: KeyValueStore | null,
  key: string,
  platform: SegmenterPlatform,
): EffectMemory | null {
  const raw = readStored(store, key)
  if (!raw) return null
  try {
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== 'object' || parsed === null) return null
    const fields = parsed as Record<string, unknown>
    const step = parseStepId(platform, fields.step)
    if (!step || !isEpochMs(fields.at)) return null
    return { step, at: fields.at }
  } catch {
    return null
  }
}

export function writeEffectMemory(
  store: KeyValueStore | null,
  key: string,
  memory: EffectMemory | null,
): void {
  writeStored(
    store,
    key,
    memory ? JSON.stringify({ step: stepId(memory.step), at: memory.at }) : null,
  )
}
